export enum EMarketStatisticsTemplate {
  GoalScored = 'GoalScored',
  Empty = 'Empty',
  LastFiveMatchesAvg = 'LastFiveMatchesAvg',
  LastFiveMeetings = 'LastFiveMeetings',
  Results = 'Results'
}
export interface IMarketStatisticsType {
  statisticsMarketType?: string;
  marketTypeDetalis?: string;
  template: EMarketStatisticsTemplate;
  title?: string;
  marketCallType?: string;
  type?: string;
  marketDataKey_individual?: string;
  marketDataKey_H2H?: string;
  emptyHeight?: string;
}

export type TMarketStatisticGame = {
  team1_id: number;
  team2_id: number;
  team1_name: string;
  team2_name: string;
};

export type THalfTimeFullTimePerformance = {
  HalfTimeFullTimePerformanceList: {
    EntityId: number;
    HalfTimeFullTimeWDLList: { HalfTime: number; FullTime: string }[];
  }[];
};

export interface IGetStatsForMatch {
  StatsForMatch: {
    MatchDetails: {
      MatchDate: string;
      MatchListItem: {
        TypeAbbreviation: string;
        HomeTeamId: number;
        AwayTeamId: number;
        HomeScore: number;
        AwayScore: number;
      }[];
    };
  }[];

  WDLResult: {
    Abbreviation: string;
    HomeWinCount: number;
    AwayWinCount: number;
    DrawCount: number;
  }[];

  WDLList: {
    EntityId: number;
    MatchResult: string[];
  }[];
}
export type TScoredGoals = {
  EntityId: number;
  FirstHalfGoals: string[];
  SecondHalfGoals: string[];
  FullTimeGoals: string[];
  BothTeamsFirstHalfGoals: string[];
  BothTeamsSecondHalfGoals: string[];
  BothTeamsFullTimeGoals: string[];
  FullTimeGoalsAvg: number;
  FirstHalfGoalsAvg: number;
  SecondHalfGoalsAvg: number;
  FullTimeScoredGoalsAvg: number;
  FirstHalfScoredGoalsAvg: number;
  SecondHalfScoredGoalsAvg: number;
};

export type TGetScoredGoalsStatistics = {
  IsH2H: boolean;
  ScoredGoals: TScoredGoals[];
};
